export default [
  {
    path: '/account-appeal',
    name: 'accountAppeal',
    redirect: '/account-appeal/index',
    component: () => import('./layout/index.vue'),
    meta: {
      name: '账号申诉',
      routerViewKey: 'accountAppeal'
    },
    children: [
      {
        path: '/account-appeal/index',
        name: 'accountAppealIndex',
        component: () => import('./index/index.vue'),
        meta: {
          name: '账号申诉',
          routerViewKey: 'accountAppeal'
        }
      },
      {
        path: '/account-appeal/submit',
        name: 'accountAppealSubmit',
        component: () => import('./submit/index.vue'),
        meta: {
          name: '账号找回',
          keepAlive: true,
          routerViewKey: 'accountAppeal'
        }
      },
    ]
  },
  {
    path: '/account-appeal/verify',
    name: 'accountAppealVerify',
    keepAlive: true,
    component: () => import('./verify/index.vue'),
    meta: {
      name: '账号找回',
      keepAlive: true,
      routerViewKey: 'accountAppeal'
    }
  },
];
